// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/EnhancementProgress.css */

.progress-container {
  padding: 2rem;
  text-align: center;
  border: 1px solid var(--border-primary);
  border-radius: 16px;
  background: var(--bg-secondary);
}

.progress-title {
  font-size: 1.5rem;
  color: var(--text-accent);
  margin-bottom: 1.5rem;
}

.progress-bar-wrapper {
  width: 100%;
  height: 24px;
  background-color: var(--border-primary);
  border-radius: var(--border-radius-full);
  margin-bottom: 1rem;
  position: relative;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background: var(--gradient-button);
  border-radius: var(--border-radius-full);
  transition: width 0.4s ease;
}

.progress-bar-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--text-primary);
  font-size: 0.9rem;
  font-weight: 600;
  text-shadow: 0 0 2px var(--bg-primary);
}

.progress-description {
  font-size: 1rem;
  color: var(--text-secondary);
  margin-bottom: 2rem;
  min-height: 1.5em;
  font-weight: 500;
}

.progress-step-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.progress-step-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  color: var(--text-secondary);
  opacity: 0.6;
}

.progress-step-item .step-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--border-primary);
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 0.9rem;
}

.progress-step-item .step-text {
  font-weight: 500;
}

/* Active Step */
.progress-step-item.active {
  color: var(--text-accent);
  opacity: 1;
  background-color: var(--bg-accent-light);
}

.progress-step-item.active .step-icon {
  background-color: var(--text-accent);
  color: white;
}

/* Spinner for active step */
.spinner-small {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Completed Step */
.progress-step-item.completed {
  color: var(--text-primary);
  opacity: 1;
}

.progress-step-item.completed .step-icon {
  background-color: var(--success-color);
  color: white;
}

.progress-step-item.completed .step-text {
  text-decoration: line-through;
  opacity: 0.7;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/styles/EnhancementProgress.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* src/styles/EnhancementProgress.css */\n\n.progress-container {\n  padding: 2rem;\n  text-align: center;\n  border: 1px solid var(--border-primary);\n  border-radius: 16px;\n  background: var(--bg-secondary);\n}\n\n.progress-title {\n  font-size: 1.5rem;\n  color: var(--text-accent);\n  margin-bottom: 1.5rem;\n}\n\n.progress-bar-wrapper {\n  width: 100%;\n  height: 24px;\n  background-color: var(--border-primary);\n  border-radius: var(--border-radius-full);\n  margin-bottom: 1rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background: var(--gradient-button);\n  border-radius: var(--border-radius-full);\n  transition: width 0.4s ease;\n}\n\n.progress-bar-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-shadow: 0 0 2px var(--bg-primary);\n}\n\n.progress-description {\n  font-size: 1rem;\n  color: var(--text-secondary);\n  margin-bottom: 2rem;\n  min-height: 1.5em;\n  font-weight: 500;\n}\n\n.progress-step-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.progress-step-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.5rem;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  color: var(--text-secondary);\n  opacity: 0.6;\n}\n\n.progress-step-item .step-icon {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background-color: var(--border-primary);\n  color: var(--text-secondary);\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.progress-step-item .step-text {\n  font-weight: 500;\n}\n\n/* Active Step */\n.progress-step-item.active {\n  color: var(--text-accent);\n  opacity: 1;\n  background-color: var(--bg-accent-light);\n}\n\n.progress-step-item.active .step-icon {\n  background-color: var(--text-accent);\n  color: white;\n}\n\n/* Spinner for active step */\n.spinner-small {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Completed Step */\n.progress-step-item.completed {\n  color: var(--text-primary);\n  opacity: 1;\n}\n\n.progress-step-item.completed .step-icon {\n  background-color: var(--success-color);\n  color: white;\n}\n\n.progress-step-item.completed .step-text {\n  text-decoration: line-through;\n  opacity: 0.7;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
